<template>
  <div class="draw-canvas">
    <div v-for="(item, index) in 3" :key="index" :class="className" class="circle" />
    <div class="canvas-text">
      <div class="number-wrap">
        <span :class="className" class="number">{{ amount >= 0 ? amount : '--' }}</span>
        <span :class="className" class="text">项</span>
      </div>
      <div :class="className" class="draw-text">待优化</div>
    </div>
    <canvas id="canvasWrap" class="canvas" width="220px" height="220px" />
  </div>
</template>

<script>
let ctx
export default {
  name: 'DrawCanvas',
  props: {
    amount: {
      type: Number,
      default: -1
    },
    total: {
      type: Number,
      default: 1
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      degrees: (1 * 2 * Math.PI) / this.total,
      sumDegrees: 0
    }
  },
  watch: {
    amount: {
      handler(newValue, oldValue) {
        const optimizedAmount = this.total - newValue
        console.log('amount', newValue, oldValue, optimizedAmount, this.total)
        if (optimizedAmount !== 0) {
          this.degrees = (optimizedAmount * 2 * Math.PI) / this.total
          window.requestAnimationFrame(this.move)
        } else if (this.total === 0) {
          this.degrees = 2 * Math.PI
          window.requestAnimationFrame(this.move)
        }
      }
    }
  },
  mounted() {
    const dom = document.querySelector('#canvasWrap')
    ctx = dom.getContext('2d')
    this.drawclock()
  },
  beforeDestroy() {
    ctx = null
  },
  methods: {
    drawclock() {
      ctx.save()
      ctx.translate(110, 110)
      ctx.rotate(Math.PI / 2)
      ctx.scale(2, 2)
      ctx.lineWidth = 2
      if (this.className === 'white') {
        ctx.strokeStyle = '#FFFFFF'
      } else {
        ctx.strokeStyle = '#e0e3e9'
      }
      ctx.lineCap = 'round'
      for (var i = 0; i < 72; i++) {
        ctx.beginPath()
        ctx.rotate(Math.PI / 36)
        ctx.moveTo(54, 0)
        ctx.lineTo(50, 0)
        ctx.stroke()
      }
      ctx.moveTo(55, 55)
      ctx.rotate(Math.PI)
    },

    move() {
      if ((this.sumDegrees * Math.PI) / 36 >= this.degrees) {
        return
      }
      // console.log('this.sumDegrees', this.sumDegrees)
      ctx.lineWidth = 2
      ctx.strokeStyle = '#77CFFF'
      ctx.beginPath()
      ctx.rotate(Math.PI / 36)
      ctx.moveTo(54, 0)
      ctx.lineTo(50, 0)
      ctx.stroke()
      this.sumDegrees += 1
      window.requestAnimationFrame(this.move)
    }
  }
}
</script>

<style lang="scss" scoped>
.draw-canvas {
  width: 110px;
  height: 110px;
  position: relative;
  .canvas {
    width: 110px;
    height: 110px;
  }
  .draw-text {
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    &.white {
      color: #ffffff;
    }
  }
  .canvas-text {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 22%;
    left: 21%;
    width: 60%;
  }
  .number-wrap {
    .number {
      height: 40px;
      font-size: 28px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: rgba(0, 145, 255, 1);
      line-height: 40px;
      &.white {
        color: #ffffff;
      }
    }
    .text {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 145, 255, 1);
      line-height: 20px;
      &.white {
        color: #ffffff;
      }
    }
  }
  .circle {
    position: absolute;
    border-radius: 50%;
  }
  .circle:nth-child(1) {
    top: 13px;
    left: -3px;
    width: 5px;
    height: 5px;
    background: rgba(91, 197, 255, 1);
    &.white {
      background: #ffffff;
    }
  }
  .circle:nth-child(2) {
    top: 83px;
    right: -5px;
    width: 5px;
    height: 5px;
    background: rgba(0, 145, 255, 1);
    &.white {
      background: #ffffff;
    }
  }
  .circle:nth-child(3) {
    top: 38px;
    left: 89px;
    width: 3px;
    height: 3px;
    background: rgba(91, 197, 255, 1);
    &.white {
      background: #ffffff;
    }
  }
}
</style>
